import { MainDiv } from "../component";
import profilePicture from "../asset/img/myProfilePicture.png";

import "../asset/style/About.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";

function About(){
    let skills= ["Node.js", "Express.js", "React.js", "MongoDB", "MySQL", "Vue.js"];
    skills= skills.map((skill)=> <li key={skill}><FontAwesomeIcon icon={faAngleRight} className="list-icon" />{skill}</li>);

    return(
        <MainDiv>
            <h1>About</h1>
            <p>I’m {process.env.REACT_APP_FULLNAME}, a curious creator and problem-solver who turns ideas into seamless web experiences. A passionate MERN stack web developer with a knack for building dynamic, high-performance web applications.</p>
            <div className="bio">
                <div className="bio_img_container">
                    <img src={profilePicture} alt={process.env.REACT_APP_FULLNAME} />
                </div>
                <div className="about">
                    <h2>Web Developer.</h2>
                    <p>With expertise in MongoDB, Express, React, and Node.js, I specialize in creating scalable, full-stack solutions that drive business growth. My goal is to deliver innovative solutions that align with business goals and provide exceptional user experiences across devices. Here’s a snapshot of my core skills and expertise:</p>
                    <ul>
                        {skills}
                    </ul>
                    <p>I thrive in versatile work environments, whether it’s remote, on-site, or hybrid. I am open to both freelance opportunities and full-time employment, allowing me to adapt my skills and expertise to meet the unique needs of each project.</p>
                </div>
            </div>
        </MainDiv>
    );
}
export default About;